import {
    Box,
    CircularProgress,
    Paper,
    Skeleton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useTheme,
    useMediaQuery
} from "@mui/material";
import React, { useState } from "react";
import { sxTypoHeader6 } from "../../configs/text_styles";
import gameService, { AgentByGameSession, GameSession } from "../../services/game_service";
import rateService, { AgentRateDetails } from "../../services/rate_service";
import { StyledTextButton } from "../../styled/filled_button";
import Spacer from "../spacing/spacer";
import PromptTypo from "../typography/typography_prompt";
import { rateDisplayTransform } from "../../configs/constants";

interface OrderTableAgentRateComponentProps {
    gameSession?: GameSession;
    summaryPrice?: String;
    ownerId?: string | number;
    agentId?: string | number;
    priceRate?: AgentRateDetails | null
}

const OrderTableAgentRateComponent: React.FC<OrderTableAgentRateComponentProps> = (
    { gameSession, ownerId, agentId, summaryPrice, priceRate }
) => {
    const [rateData, setRateData] = React.useState<any>(undefined);
    const [areLoading, setAreLoading] = useState({ rate: false, game: false, ticket: false });
    const [agentData, setAgentData] = React.useState<any>();
    const muiTheme = useTheme();
    const isSmallScreen = useMediaQuery(muiTheme.breakpoints.down('sm'));

    const handleNumberInput = (input: string) => {
        // processLotteryTicketNumber();
    }

    const fetchAgent = async () => {
        console.log('gameSession', gameSession);
        if (!ownerId) return;
        try {
            setAreLoading({ ...areLoading, game: true });
            const response = await gameService.listAgentByGameId({ gameId: gameSession?.id, agentId });
            const responseData = response?.data ?? [];
            const responseArray = responseData as AgentByGameSession[];
            const agentData = responseArray.length > 0 ? responseArray[0] : null;
            setAgentData(agentData);
            setAreLoading({ ...areLoading, game: false });


        } catch (error) {
            setAreLoading({ ...areLoading, game: false });
        }
    }

    const fetchRates = async () => {
        if (!ownerId) return;
        try {
            setAreLoading({ ...areLoading, rate: true });
            const response = await rateService.listOwnerRates(+ownerId, { ownerId: ownerId, agentID: agentId });
            const responseData = response?.data ?? [];
            const agentRate = responseData.find((f) => f.agentId === agentId) ?? null;

            setAreLoading({ ...areLoading, rate: false });
        } catch (error) {
            // setAreLoading({ ...areLoading, rate: false });
        }
    }

    React.useEffect(() => {
        fetchAgent();
    }, []);
    React.useEffect(() => {
        if (priceRate) {
            const agentRateTransformed = rateDisplayTransform(JSON.parse(JSON.stringify(priceRate)));
            setRateData(agentRateTransformed);
        }
    }, [priceRate]);

    return (
        <TableContainer
            component={Paper}
            sx={{
                padding: '0px 16px',
                marginTop: "16px",
                bgcolor: muiTheme.palette.background.default,
                borderRadius: 4,
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
                overflow: 'auto',
            }}
        >
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                sx={{
                    padding: '4px 16px',
                    marginTop: 1,
                    alignItems: { xs: 'flex-start', sm: 'center' },
                }}
            >
                <PromptTypo
                    variant="subtitle1"
                    fontWeight={'bold'}
                    sx={{
                        marginTop: { xs: 0, sm: "6px" },
                        alignSelf: 'flex-start',
                    }}
                >
                    สมาชิก
                </PromptTypo>
                <Spacer size="xl" />
                <Box sx={{ width: '100%' }}>
                    <Stack direction="column" alignItems="flex-start">
                        <StyledTextButton disabled>
                            <PromptTypo
                                sx={{ fontWeight: 'bold' }}
                                variant="body2" >
                                {agentData?.agentFirstname ?? ''} {agentData?.agentLastname ?? ''}
                            </PromptTypo>
                        </StyledTextButton>
                        <StyledTextButton disabled>
                            <PromptTypo variant="body2">
                                {`(${agentData?.agentCode ?? ''})`}
                            </PromptTypo>
                        </StyledTextButton>
                    </Stack>
                </Box>
            </Stack>
            <Box sx={{ padding: '0px 0px 16px 16px' }}>
                <Typography variant="subtitle1" sx={sxTypoHeader6}>
                    ราคาจ่าย
                </Typography>
            </Box>
            <Box
                sx={{
                    maxHeight: "calc(70vh - 120px)",
                    overflowY: 'auto', // Enable vertical scrolling
                }}
            >
                {!areLoading.rate ? (
                    <TableContainer sx={{ height: '100%', }} >
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', width: '50%' }}>ชนิด</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 'bold', width: '25%' }}>จ่าย</TableCell>
                                    <TableCell align="right" sx={{ fontWeight: 'bold', width: '25%' }}>ลด %</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rateData?.map((row: any, index: number) => (
                                    <TableRow key={index}>
                                        <TableCell sx={{ width: '50%' }}>{row.type}</TableCell>
                                        <TableCell align="right" sx={{ width: '25%' }}>{row.pay}</TableCell>
                                        <TableCell align="right" sx={{ width: '25%' }}>{row.discount}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <TableContainer>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Skeleton variant="text" width="40%" />
                                    </TableCell>
                                    <TableCell align="right">
                                        <Skeleton variant="text" width="20%" />
                                    </TableCell>
                                    <TableCell align="right">
                                        <Skeleton variant="text" width="20%" />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.from({ length: 5 }).map((_, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Skeleton variant="text" width="80%" />
                                        </TableCell>
                                        <TableCell align="right">
                                            <Skeleton variant="text" width="40%" />
                                        </TableCell>
                                        <TableCell align="right">
                                            <Skeleton variant="text" width="30%" />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        </TableContainer>
    );
};

export default OrderTableAgentRateComponent;
